"use client";

import { AnimatePresence, motion } from "framer-motion";
import Icon from "@/components/icons/Icons";

interface NavigationButtonsProps {
  currentStep: number;
  prevStep: () => void;
  nextStep: () => void;
  isLastStep: boolean;
  isSubmitting: boolean;
}
export default function NavigationButtons({
  currentStep,
  prevStep,
  nextStep,
  isLastStep = false,
  isSubmitting = false,
}: NavigationButtonsProps) {
  return (
    <div className="flex items-center justify-center gap-3 sm:gap-4 text-center border-t border-[#DCDCDC] pt-4 xs:pt-5 sm:pt-8">
      <AnimatePresence mode="wait">
        {currentStep > 1 && (
          <motion.button
            key="back-button"
            type="button"
            onClick={prevStep}
            disabled={isSubmitting}
            initial={{
              opacity: 0,
              width: 0,
              x: -20,
            }}
            animate={{
              opacity: 1,
              width: "160px",
              x: 0,
            }}
            exit={{
              opacity: 0,
              width: 0,
              x: -20,
            }}
            transition={{
              duration: 0.25,
              ease: "easeInOut",
            }}
            className="overflow-hidden py-2.5 sm:py-3 lg:py-3.5 flex items-center justify-center gap-3 rounded-full border sm:border-2 border-[#10746F] text-sm sm:text-base lg:text-xl leading-1.3! font-semibold text-[#10746F] hover:bg-[#10746f15]"
          >
            <Icon.rightArrow className="w-5 h-5 rotate-180 shrink-0" />
            <span className="hidden xs:block">Back</span>
          </motion.button>
        )}
      </AnimatePresence>

      <button
        type="button"
        onClick={nextStep}
        disabled={isSubmitting}
        className="w-full xxs:max-w-80 py-3.5 rounded-full border border-[#10746F] bg-[#10746F] text-sm sm:text-base lg:text-xl leading-1.3! font-semibold text-white shine-button-hover disabled:opacity-50"
      >
        {isSubmitting ? "Submitting..." : isLastStep ? "Submit" : "Continue"}
      </button>
    </div>
  );
}
